
<p-dataView 
  [value]="properties"
  [rows]="rows"
  [lazy]="lazy"
  [loading]="loading"
  [paginator]="paginator"
  [totalRecords]="totalRecords"
  [emptyMessage]="''"
  paginatorPosition="both"
  [rowsPerPageOptions]="[10,25,50]"
  (onLazyLoad)="loadData($event)">
  <p-header>
    <div class="search-container">
      <div class="excelStyle">
        <span class="fa fa-file-excel-o"  style="font-size: 1.5em"></span>&nbsp;
        <a href="{{exportExcel()}}" class="excelLink">Download To Excel</a>
      </div>
    </div>
  </p-header>
  <ng-template let-property pTemplate="listItem">
    <ng-container [ngSwitch]="property.DispositionStrategyGroupKey">
      <div>
        <p-card styleClass="ui-card-shadow" [style]="{'margin':'7px 0 7px 0'}">
          <tpl-property-search-reo [iconLeft]="'home'" 
            *ngSwitchCase="'reo'" 
            showPropertyIdLink 
            showOpenNewWindowIcon 
            [value]="property" 
            [routes]="routes"
          ></tpl-property-search-reo>
          <tpl-property-search-auction [iconLeft]="'home'" 
            *ngSwitchCase="'auction'" 
            showPropertyIdLink 
            showOpenNewWindowIcon 
            [value]="property" 
            [routes]="routes"
          ></tpl-property-search-auction>
          <tpl-property-search-foreclosure-auction [iconLeft]="'home'" 
            *ngSwitchCase="'auc-fcl'" 
            showPropertyIdLink 
            showOpenNewWindowIcon 
            [value]="property" 
            [routes]="routes"
          ></tpl-property-search-foreclosure-auction>
          <tpl-property-search-shortsale [iconLeft]="'hospital'" 
            *ngSwitchCase="'shortsale'" 
            showPropertyIdLink 
            showOpenNewWindowIcon 
            [value]="property" 
            [routes]="routes"
          ></tpl-property-search-shortsale>
          <tpl-property-search-forclosure [iconLeft]="'home'" 
            *ngSwitchCase="'fcbk'" 
            showPropertyIdLink 
            showOpenNewWindowIcon 
            [value]="property" 
            [routes]="routes"
          ></tpl-property-search-forclosure>
          <tpl-property-search-preforclosure [iconLeft]="'home'" 
          *ngSwitchCase="'pre-fcl'"  
          showPropertyIdLink 
          showOpenNewWindowIcon
          [value]="property" 
          [routes]="routes">
        </tpl-property-search-preforclosure>
          <tpl-property-search-default [iconLeft]="'home'" 
            *ngSwitchDefault 
            showPropertyIdLink 
            showOpenNewWindowIcon 
             [value]="property"
             [routes]="routes"
          ></tpl-property-search-default>
        </p-card>
      </div>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="paginatorright">
    <span *ngIf="!loading">{{totalRecords}} Records Found</span>
  </ng-template>
  
</p-dataView>
